import React from 'react';
import { Link } from 'react-router-dom';
import { Zap } from 'lucide-react';

const FOOTER_LINKS = {
  Product: [
    { label: 'Playbooks', to: '/playbooks' },
    { label: 'Examples', to: '/gallery' },
    { label: 'Pricing', to: '/pricing' },
    { label: 'MCP Setup', to: '/mcp-setup' },
  ],
  Solutions: [
    { label: 'Enterprise', to: '/enterprise' },
    { label: 'Startups', to: '/solutions' },
    { label: 'Consultants', to: '/solutions' },
    { label: 'Academics', to: '/solutions' },
  ],
  Company: [
    { label: 'About', to: '/about' },
    { label: 'Security', to: '/security' },
    { label: 'Investors', to: '/investors' },
  ],
  Legal: [
    { label: 'Terms of Service', to: '/terms' },
    { label: 'Privacy Policy', to: '/privacy' },
  ],
};

export default function Footer() {
  return (
    <footer className="border-t border-[rgba(245,241,232,0.08)] bg-[#0A0A0A]">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        {/* Links grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 py-12 md:py-16">
          {Object.entries(FOOTER_LINKS).map(([section, links]) => (
            <div key={section}>
              <h4 className="text-xs font-mono text-[rgba(245,241,232,0.48)] tracking-wider uppercase mb-4">
                {section}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-[rgba(245,241,232,0.72)] hover:text-[#FF4D00] transition-colors font-body"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 py-6 border-t border-[rgba(245,241,232,0.08)]">
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 bg-[#FF4D00] flex items-center justify-center" style={{ clipPath: 'polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%)' }}>
              <Zap className="w-3 h-3 text-[#0A0A0A]" />
            </div>
            <span className="text-sm font-display font-bold text-[#F5F1E8] tracking-tight uppercase">
              Fray
            </span>
          </div>
          <p className="text-xs text-[rgba(245,241,232,0.32)] font-mono">
            &copy; {new Date().getFullYear()} Fray AI. Decision insurance for teams that think.
          </p>
        </div>
      </div>
    </footer>
  );
}
